import {
  RegisterNetworkData,
  Address,
} from 'components/NetworkRegister/NetworkRegisterInterface/NetworkRegisterInterface';

export const emptyAddress: Address = {
  postCode: '',
  houseNr: '',
  line1: '',
  line2: '',
  city: '',
  county: '',
  residentFrom: '',
};

export const initialState: RegisterNetworkData = {
  fcaNumber: '',
  networkName: '',
  postCode: '',
  houseNr: '',
  line1: '',
  line2: '',
  city: '',
  county: '',
  email: '',
  phoneNumber: '',
  commissionTerms: '',
  sortCode: '',
  accNumber: '',
  accName: '',
  submissionRoute: null,
  directors: [
    {
      title: '',
      firstName: '',
      middleName: '',
      surname: '',
      dateOfBirth: '',
      gender: '',
      addresses: [{ postCode: '', houseNr: '', line1: '', line2: '', city: '', county: '', residentFrom: '' }],
    },
  ],
};
